import React from "react";
import { themed } from "../skins/styles";
const _AspectRatio = ({ className, children, ratio, ...otherProps }) => {
    return (React.createElement("div", { ...otherProps, "data-aspect-ratio": ratio, className: className },
        React.createElement("div", { className: "innerWrapper" }, children)));
};
_AspectRatio.defaultProps = {
    "data-testid": "aspect-ratio-container",
};
export const AspectRatio = themed(_AspectRatio);
//# sourceMappingURL=AspectRatio.js.map